module.exports = __webpack_public_path__ + "static/media/control_de_carga3.d1bcc0a8.svg";